export enum TestResultElementAnnotationType {
    ERROR,
    WARNING
}
